module.exports = __webpack_public_path__ + "static/media/asset_1.22535c84.svg";